const classes = {
    textTitle: {
        color: '#103168',
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: 20
    },
    paper: {
        padding: 16,
        display: "inline-block",
        width: "100%",
        overflow: "auto",
        flexDirection: "row",
        minWidth: "calc(100%)",
        marginRigth: "20px",
        backgroundColor: "#F5F5F5",
    },
};


export default classes;